import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { useServiceAccountCreatePage } from "../../../../hooks/service-account/service-account-create";
import { ServiceAccountCreateButtons } from "../../../organisms/service-account/service-account-create-buttons";
import { ServiceAccountCreateForm } from "../../../organisms/service-account/service-account-create-form";
import { ServiceProviderTemplate } from "../../../template/service-provider/default-template";
import { ServiceProviderR } from "../routes";

export const ServiceAccountCreatePage: React.FC = () => {
  const { tenantId } = useParams<{ tenantId: string }>();

  const {
    input,
    setInput,
    createServiceAccount,
    isLoading,
    validationState,
    shouldDisplayError,
  } = useServiceAccountCreatePage({ tenantId });

  const history = useHistory();

  const handleCreate = React.useCallback(() => {
    createServiceAccount({
      onSucceeded: (serviceAccount) => {
        history.push(
          ServiceProviderR.ServiceAccountDetail.link({
            tenantId: serviceAccount.tenantId,
            serviceAccountId: serviceAccount.id,
            isNewlyCreated: true,
          }),
        );
      },
      onFailed: (msg) => {
        toast.error(msg);
      },
    });
  }, [createServiceAccount, history]);

  const handleCancel = React.useCallback(() => {
    history.push(ServiceProviderR.ServiceAccounts.link({ tenantId }));
  }, [history, tenantId]);

  return (
    <ServiceProviderTemplate
      breadcrumbs={[
        {
          to: ServiceProviderR.Home.link({}),
          title: "Home",
        },
        {
          to: ServiceProviderR.ServiceAccounts.link({ tenantId }),
          title: "サービスアカウント",
        },
        {
          to: ServiceProviderR.ServiceAccountCreate.link({ tenantId }),
          title: "新規登録",
        },
      ]}
    >
      <Title />
      <ServiceAccountCreateButtons
        onCreate={handleCreate}
        onCancel={handleCancel}
        isLoading={isLoading}
      />
      <ServiceAccountCreateForm
        createServiceAccountInput={input}
        onChange={setInput}
        tenantId={tenantId}
        validationState={validationState}
        shouldDisplayError={shouldDisplayError}
      />
    </ServiceProviderTemplate>
  );
};

const Title: React.FC = () => {
  return (
    <div className="columns is-vcentered">
      <div className="column has-text-left">
        <h1 className="title">サービスアカウントの新規登録</h1>
      </div>
    </div>
  );
};
